import { useContext } from 'react';
import { WorkflowContext, WorkflowStoreType } from '../../../features/workflow/hub/workflowSocketProvider';
import { useStore } from 'zustand';
export const useWorkflowSocket = <U>(selector: Parameters<typeof useStore<WorkflowStoreType, U>>[1]) => {
  const store = useContext(WorkflowContext);
  if (!store) throw new Error('missing workflow connection');
  return useStore(store, selector);
};
